
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface Service {
  id: string;
  provider_id: string;
  name: string;
  description: string;
  service_type: string;
  duration_minutes: number;
  reserved_duration_minutes: number;
  price: number;
  currency: string;
  image_url?: string;
  room_id?: string;
  created_at: string;
  updated_at: string;
  room?: {
    id: string;
    name: string;
    description?: string;
    capacity: number;
  };
}

export const useServices = (providerId?: string) => {
  return useQuery({
    queryKey: ['services', providerId],
    queryFn: async () => {
      let query = supabase
        .from('services')
        .select(`
          *,
          room:rooms(id, name, description, capacity)
        `);
      
      if (providerId) {
        query = query.eq('provider_id', providerId);
      }
      
      const { data, error } = await query.order('created_at', { ascending: true });

      if (error) {
        console.error('Error fetching services:', error);
        throw error;
      }

      return data as Service[];
    },
  });
};

export const useDeleteService = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (serviceId: string) => {
      const { error } = await supabase
        .from('services')
        .delete()
        .eq('id', serviceId);

      if (error) {
        console.error('Error deleting service:', error);
        throw error;
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['services'] });
      queryClient.invalidateQueries({ queryKey: ['room-services'] });
    },
  });
};
